import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(payment)/_components/PathComsumer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Footer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderPayment"] */ "/app/src/components/Header/AppBarPay/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/providers/AuthProvider.tsx");
